import React from "react";
import { useIntl } from "react-intl";
import { TableFooter, TablePagination, TableRow } from "@mui/material";

type Props = {
  pagination: {
    length: number;
    loading: boolean;
    rowsPerPage: number;
    page: number;
    changePage: Function;
    changeRowsPerPage: Function;
  };
};

function TablePaginationComponent({ pagination }: Props): JSX.Element {
  const { formatMessage } = useIntl();
  const { length, loading, rowsPerPage, page, changePage, changeRowsPerPage } =
    pagination;

  if (loading || !pagination || length === 0) return <></>;

  return (
    <TableFooter>
      <TableRow>
        {/* @ts-ignore */}
        <TablePagination
          count={length}
          rowsPerPageOptions={[5, 10, 25]}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={changePage}
          onRowsPerPageChange={changeRowsPerPage}
          labelRowsPerPage={formatMessage({
            id: "components.table.labelRowsPerPage",
          })}
          labelDisplayedRows={({ from, to, count }) =>
            formatMessage(
              {
                id: "components.table.labelDisplayedRows",
              },
              {
                from,
                to,
                count,
              }
            )
          }
        />
      </TableRow>
    </TableFooter>
  );
}

export default TablePaginationComponent;
